import { useDispatch } from "react-redux";
import fetchServer from "../controllers/fetchServer";
import { setTrainings } from "../redux/reducers/settings/academySettingSlice";
import { enqueueSnackbar } from "notistack";

export default function useSmsTemplate() {
  const getSmsTemplates = async (setLoading) => {
    try {
      setLoading && setLoading(true);

      const res = await fetchServer({
        method: "GET",
        url: `/notification/v2/sms-template`,
      });

      if (!res) return null;

      if (res.status === 200 || res.status === 201) {
        return res?.data?.data?.templates;
      } else {
        enqueueSnackbar(
          res?.data?.message || "Something went wrong. please try again later.",
          {
            variant: "error",
          }
        );
        return null;
      }
    } catch (err) {
      enqueueSnackbar("Network error", { variant: "error" });
      return null;
    } finally {
      setLoading && setLoading(false);
    }
  };

  const createSmsTemplate = async (setLoading, payload) => {
    try {
      setLoading?.(true);

      const res = await fetchServer({
        method: "POST",
        url: `/notification/v2/sms-template`,
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res?.status === 200 || res?.status === 201) {
        enqueueSnackbar("Template created successfully!", {
          variant: "success",
        });

        return { success: true };
      }

      enqueueSnackbar(res?.message || "Failed to create template!", {
        variant: "error",
      });

      return { success: false };
    } catch (err) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      return { success: false, error: err };
    } finally {
      setLoading?.(false);
    }
  };

  const getSmsTemplateVariables = async (setLoading) => {
    try {
      setLoading && setLoading(true);

      const res = await fetchServer({
        method: "GET",
        url: `/notification/v2/template-variables`,
      });

      if (!res) return null;

      if (res.status === 200 || res.status === 201) {
        return res?.data?.data;
      } else {
        enqueueSnackbar(
          res?.data?.message || "Something went wrong. please try again later.",
          {
            variant: "error",
          }
        );
        return null;
      }
    } catch (err) {
      enqueueSnackbar("Network error", { variant: "error" });
      return null;
    } finally {
      setLoading && setLoading(false);
    }
  };

  const deleteSmsTemplate = async (setLoading, templateKey) => {
    try {
      setLoading?.(true);

      const res = await fetchServer({
        method: "DELETE",
        url: `/notification/v2/sms-template/${templateKey}`,
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res?.status === 200 || res?.status === 204) {
        enqueueSnackbar("Template deleted successfully!", {
          variant: "success",
        });
        return { success: true };
      }

      enqueueSnackbar(res?.message || "Failed to delete template!", {
        variant: "error",
      });
      return { success: false };
    } catch (err) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      return { success: false, error: err };
    } finally {
      setLoading?.(false);
    }
  };

  const updateSmsTemplate = async (setLoading, payload, templateKey) => {
    try {
      setLoading?.(true);

      const res = await fetchServer({
        method: "PATCH",
        url: `/notification/v2/sms-template/${templateKey}`,
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res?.status === 200 || res?.status === 201) {
        enqueueSnackbar("Template created successfully!", {
          variant: "success",
        });

        return { success: true };
      }

      enqueueSnackbar(res?.message || "Failed to create template!", {
        variant: "error",
      });

      return { success: false };
    } catch (err) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      return { success: false, error: err };
    } finally {
      setLoading?.(false);
    }
  };

  return {
    getSmsTemplates,
    createSmsTemplate,
    getSmsTemplateVariables,
    deleteSmsTemplate,
    updateSmsTemplate,
  };
}
